import { Suspense, lazy } from 'react';
import { useHistory } from 'react-router-dom';
import useHashFlag from '../../../hooks/useHashFlag';
import HASH_FLAGS from '../../../routes/hashFlags.const';
import PATHS from '../../../routes/routes.const';
import useCanManageBrandCatalogs from '../hooks/useCanManageBrandCatalogs';

const CatalogCreationModal = lazy(() => import('./CatalogCreationModal'));

const GlobalCatalogCreationModal = () => {
  const { isOpen, close } = useHashFlag(HASH_FLAGS.createCatalog);
  const canCreateCatalogs = useCanManageBrandCatalogs();
  const history = useHistory();

  if (!isOpen || !canCreateCatalogs) {
    return null;
  }

  const handleCreated = (catalogId: string) => {
    history.replace(PATHS.main.catalogs.products.path.replace(':id', catalogId));
  };

  return (
    <Suspense fallback={null}>
      <CatalogCreationModal isOpen onClose={close} onCreated={handleCreated} />
    </Suspense>
  );
};

export default GlobalCatalogCreationModal;
